import FormPaperLayout, { FormPaperLayoutProps } from "./FormPaperLayout";
export default FormPaperLayout;
export { FormPaperLayoutProps };
